/* istanbul ignore next */
export const gaLabelFormatter = (gaLabel: string) => {
  return gaLabel.split('/').splice(0, 6).join('/') + '/';
};
